import { Patch } from "rfc6902";
import { isVariantPatch } from "./isVariantPatch";
import { isVariantTemplate, VariantTemplate } from "./isVariantTemplate";

export interface VariantInformation {
  allVariantPatches: Record<string, Patch>;
  variantTemplates: VariantTemplate[];
}

/**
 * Type guard that asserts whether a value conforms to the VariantInformation shape.
 *
 * @param obj - The object to check
 * @returns true if the object is a VariantInformation, false otherwise
 */
export const isVariantInformation = (obj: unknown): obj is VariantInformation => {
  if (typeof obj !== "object" || obj === null) return false;
  const chkObj = obj as VariantInformation;
  if (
    typeof chkObj.allVariantPatches !== "object" ||
    chkObj.allVariantPatches === null ||
    Array.isArray(chkObj.allVariantPatches)
  )
    return false;
  if (Object.values(chkObj.allVariantPatches).some((patch) => !isVariantPatch(patch))) return false;
  if (
    !Array.isArray(chkObj.variantTemplates) ||
    chkObj.variantTemplates.some((item) => !isVariantTemplate(item))
  )
    return false;

  return true;
};
